import * as React from 'react';
import { LessonId } from '../../../../types/lessons';
import './courseLessonItem.module.scss';
import { SectionId, SectionSuccinctIndexView } from '../../../../types/sections';
import classNames from 'classnames';
import { LessonState } from '../../../../containers/courses/states/LessonState';
import { observer } from 'mobx-react';
import ChevronRight from './images/chevron-right.svg';
import { BodyText, Button, Heading } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';

type SectionListProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  children: any;
};

type SectionItemProps = {
  index: number;
  section: SectionSuccinctIndexView[];
  activated: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick: () => any;
};

const SectionList = ({ children }: SectionListProps) => <div styleName="section-list">{children}</div>;
const SectionItem = ({ index, section, activated, onClick }: SectionItemProps) => (
  <div styleName={classNames('section-item', { activated: activated })} onClick={activated ? onClick : undefined}>
    <BodyText>
      <span styleName="section-index">{String(index + 1).padStart(2, '0')}.</span> {section.title}
    </BodyText>
    <img src={ChevronRight} styleName="chevron-right" />
  </div>
);

type Props = {
  index: number;
  lesson: LessonState;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onLessonStart: (lessonId: LessonId) => any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSectionClick: (sectionId: SectionId) => any;
};

export const CourseLessonItem = observer(
  class CourseLessonItem extends React.Component<Props> {
    render() {
      const { index, lesson, onLessonStart, onSectionClick } = this.props;
      return (
        <div styleName="course-lesson-item">
          <div styleName="header">
            <div>
              <div styleName="lesson-no">LESSON {index + 1}</div>
              <Heading size={GlobalStatesV3.viewport.isSp ? 'S' : 'M'}>{lesson.lesson.title}</Heading>
            </div>
            <div styleName="button-wrapper">
              <Button
                id={`begin-button-${index}`}
                variant="secondary"
                isLoading={lesson.loading}
                onClick={() => onLessonStart(lesson.lesson.id)}
                fullWidth={GlobalStatesV3.viewport.isSp}
              >
                {lesson.isActivated ? 'つづきからはじめる' : 'はじめる'}
              </Button>
            </div>
          </div>
          <SectionList>
            {lesson.lesson.sections.map((section, index) => (
              <SectionItem
                key={section.id}
                index={index}
                section={section}
                activated={lesson.isActivated}
                onClick={() => onSectionClick(section.id)}
              />
            ))}
          </SectionList>
        </div>
      );
    }
  }
);
